import contactOpenRoom from './contact-open-room';
import contactOpenLasertag from './contact-open-lasertag';
import contactEvent from './contact-event';
import contactExpo from './contact-expo';
import contactGeneral from './contact-general';
import contactParty from './contact-party';
import contactTeamBuilding from './contact-team-building';
import contactBusiness from './contact-business';

// Contact open room
new contactOpenRoom('#form-open-room-vr', '#btn-form-open-room-vr');

// Contact open lasertag
new contactOpenLasertag('#form-open-lasertag', '#btn-form-open-lasertag');

// Contact event
new contactEvent('#form-organize-event', '#btn-form-organize-event');

// Contact expo
new contactExpo('#form-expo', '#btn-form-expo');

// Contact general
new contactGeneral('#form-contact-general', '#btn-form-contact-general');

// Contact party
new contactParty('#form-party', '#btn-form-party');

// Contact party
new contactTeamBuilding('#form-team-building', '#btn-form-team-building');

// Contact business
new contactBusiness('.form-business', '#btn-form-business');